export default __webpack_public_path__ + "static/media/user.ac2d02c0.svg";